// components/LoginForm.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom'; // << เพิ่มบรรทัดนี้

export default function LoginForm() {
  const navigate = useNavigate(); // << ใช้ Hook นี้

  const handleLogin = () => {
    // ถ้าต้องการ validate ก่อนก็ทำได้
    // ตอนนี้ทำแค่เด้งไป Dashboard เลย
    navigate('/dashboard');
  };

  return (
    <div className="login-box">
      <div className="icon">👤</div>
      <h2>Login</h2>
      <input type="email" placeholder="Your Email" />
      <input type="password" placeholder="Password" />
      <button onClick={handleLogin}>Login</button> {/* << ผูก onClick */}
    </div>
  );
}
